import { Controller } from "@hotwired/stimulus";

// Keeps an Ask conversation scrolled to the newest message: on load, and as
// content arrives (a streamed answer growing, or the page refreshing once
// it's saved), but only while the reader is at the bottom, so it never pulls
// them away from something higher up they're reading.
export default class extends Controller {
  connect() {
    this.atBottom = true;
    this.scrollToEnd();
    this.trackPosition = () => {
      const { scrollHeight, scrollTop, clientHeight } = this.element;
      this.atBottom = scrollHeight - scrollTop - clientHeight < 80;
    };
    this.element.addEventListener("scroll", this.trackPosition, { passive: true });
    this.observer = new MutationObserver(() => { if (this.atBottom) this.scrollToEnd(); });
    this.observer.observe(this.element, { childList: true, subtree: true, characterData: true });
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.trackPosition);
    this.observer?.disconnect();
  }

  scrollToEnd() {
    this.element.scrollTop = this.element.scrollHeight;
  }
}
